import Button from "./Button";
import "./Event.css";
import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";

const Event = (props) => {
  //! osetreni na null
  const dateFrom = props.from ? new Date(props.from) : null;
  const dateTo = props.to ? new Date(props.to) : null;

  const dayFrom = dateFrom ? String(dateFrom.getDate()).padStart(2, "0") : "00";
  const monthFrom = dateFrom
    ? dateFrom.toLocaleString("default", { month: "long" })
    : "Invalid";
  const yearFrom = dateFrom ? dateFrom.getFullYear() : "0000";

  const dayTo = dateTo ? String(dateTo.getDate()).padStart(2, "0") : "00";
  const monthTo = dateTo
    ? dateTo.toLocaleString("default", { month: "long" })
    : "Invalid";
  const yearTo = dateTo ? dateTo.getFullYear() : "0000";
  const [truncatedDescription, setTruncatedDescription] = useState("");

  const getDescriptionLength = () => {
    if (window.innerWidth < 576) {
      return 100;
    } else if (window.innerWidth < 768) {
      return 150;
    } else if (window.innerWidth < 1200) {
      return 250;
    } else {
      return 400;
    }
  };

  const truncateDescription = useCallback(() => {
    const length = getDescriptionLength();
    setTruncatedDescription(props.overview.slice(0, length) + "...");
  }, [props.overview]);

  useEffect(() => {
    truncateDescription();
    window.addEventListener("resize", truncateDescription);
    return () => {
      window.removeEventListener("resize", truncateDescription);
    };
  }, [truncateDescription]);

  return (
    <div className="d-flex flex-column event">
      <div className="event-top"></div>
      <h3 className="ps-2 pt-2 event-title">{props.name}</h3>
      <div className="event-line ms-2"></div>
      <h5 className="p-2 pt-3">
        {dateFrom !== null && (
          <>
            {dayFrom}. {monthFrom} {yearFrom}
          </>
        )}
        {dateTo !== null && (
          <>
            -{dayTo}. {monthTo} {yearTo}
          </>
        )}
      </h5>
      <div className="p-2 pt-0">{truncatedDescription}</div>
      <div className="text-end m-auto">
        <Link to={`/projekty/detail/${props.id}`}>
          <Button text="Detail" />
        </Link>
      </div>
    </div>

    // <div className="d-flex event col-12 col-md-10 col-lg-8">
    //   <div className="event-date text-center">
    //     <span className="event-day">{day}</span> <br />
    //     <span className="event-month">{month}</span>
    //     <br />
    //   </div>
    //   <div className="event-text">
    //     <h3>{props.name}</h3>
    //     <p>{truncatedDescription}</p>
    //     <div className="text-end">
    //       <Link to={`/udalosti/detail/${props.id}`}>
    //         <Button text="Detaily události" />
    //       </Link>
    //     </div>
    //   </div>
    // </div>

    // <div className="row mt-5">
    //   <div className="col-xl-2 col-4 p-2 event-date-background text-center">
    //     <span className="event-day">{day}</span> <br />
    //     <span className="event-month">{month}</span>
    //     <br />
    //   </div>
    //   <div className="col-xl-10 col-8">
    //     <h3>{props.name}</h3>
    //     <p>{truncatedDescription}</p>
    //     <div className="text-end">
    //       <Link to={`/udalosti/detail/${props.id}`}>
    //         <Button text="Detaily události" />
    //       </Link>
    //     </div>
    //   </div>
    // </div>
  );
};
export default Event;
